
import "@ganache/cli/src/cli";
